module.exports = __webpack_public_path__ + "img/Mall-of-Joy.8b8d3e05.jpg";